import React from 'react'
import { Modal } from 'react-bootstrap'
import i18next from 'i18next'
import Notificator from './Notificator'

export default class NoMoreCredits extends React.Component {
  render() {
    const { handleDismiss } = this.props

    return (
      <Modal show={true}>
        <Modal.Body style={{ backgroundColor: '#F3DFF1', borderRadius: 6 }}>
          <Notificator type="error">
            <h1>{i18next.t('oops')}</h1>

            <p>{i18next.t('invitation_no_more_wopi_credits')}.</p>

            <p>
              <a href="#" onClick={handleDismiss}>
                {i18next.t('dismiss_no_more_wopi_credits')}
              </a>
            </p>
          </Notificator>
        </Modal.Body>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NoMoreCredits.js